import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SignIn from "@/pages/SignIn";
import AppShell from "@/components/AppShell";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import Simulator from "@/pages/Simulator";
import Catalog from "@/pages/Catalog";
import Orders from "@/pages/Orders";
import Training from "@/pages/Training";
import QuickReplies from "@/pages/QuickReplies";
import Settings from "@/pages/Settings";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route element={<AppShell />}>
        <Route path="/dashboard" element={<Home />} />
        <Route path="/chats" element={<Dashboard />} />
        <Route path="/simulador" element={<Simulator />} />
        <Route path="/catalogo" element={<Catalog />} />
        <Route path="/pedidos" element={<Orders />} />
        <Route path="/entrenar" element={<Training />} />
        <Route path="/respuestas" element={<QuickReplies />} />
        <Route path="/ajustes" element={<Settings />} />
        <Route path="/settings" element={<Navigate to="/ajustes" replace />} />
      </Route>
      <Route path="*" element={<SignIn />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}
